// Libs
import Translation from 'libs/Translation';

// Components
import ReadMore from 'components/common/ReadMore';
import Text from 'components/common/Text';

const DoctorBio = ({ doctor }) => {
    return (
        <div className='box'>
            <Text 
                tag="h2"
                color="#0D2439"
                className="title"
            >
                {Translation.t('title.doctor-bio')}
            </Text>
            {doctor?.MedicalCode &&
            <Text 
                tag="h3"
                color="#61788E"
            >
                {Translation.t('label.medical-system-code', {code: Translation.n(doctor.MedicalCode) })}
            </Text>
            }
            {doctor.Biography.length > 150 ?
            <ReadMore 
                text={Translation.n(doctor.Biography)}
                tag='h3'
            />
            :
            <Text
                className="text margin-1"
                color="#61788E"
            >
                {Translation.n(doctor.Biography)}
            </Text>
            }
        </div>
    )
}
export default DoctorBio;